/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetSegmentsRangeQueryResponse, SegmentsGetSegmentsRangePathParams, SegmentsGetSegmentsRangeQueryParams, SegmentsGetSegmentsRange400, SegmentsGetSegmentsRange401, SegmentsGetSegmentsRange403, SegmentsGetSegmentsRange404 } from "../models/SegmentsGetSegmentsRange";

export function getSegmentsGetSegmentsRangeUrl(station: SegmentsGetSegmentsRangePathParams["station"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/segments` as const }
  return res
}

/**
 * @description Returns full segment data for the given time range. Optional query flags control whether media URLs, waveform, and I-frame metadata are included.
 * @summary List segments for the specified interval
 * {@link /segments/v1/stations/:station/segments}
 */
export async function segmentsGetSegmentsRange(station: SegmentsGetSegmentsRangePathParams["station"], params: SegmentsGetSegmentsRangeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetSegmentsRangeQueryResponse, ResponseErrorConfig<SegmentsGetSegmentsRange400 | SegmentsGetSegmentsRange401 | SegmentsGetSegmentsRange403 | SegmentsGetSegmentsRange404>, unknown>({ method : "GET", url : getSegmentsGetSegmentsRangeUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}